import { makeSelectFertilizerProductValue } from 'services/fertilizerProducts/selectors';
import createDeepEqualSelector from 'utils/reselect/typescript/createDeepEqualSelector';

const selectReEntryPeriodDays = createDeepEqualSelector(
    makeSelectFertilizerProductValue('reEntryPeriodDays'),
    (reEntryPeriodDays) => reEntryPeriodDays
);

const makeSelectReEntryPeriodDays = (): typeof selectReEntryPeriodDays =>
    selectReEntryPeriodDays;

export { makeSelectReEntryPeriodDays };
